import React, { useCallback, useEffect } from 'react';
import OnboardingVideo from 'components/OnboardingVideo';
import OverviewLayout from 'components/OverviewLayout/OverviewLayout';
import { useHistory } from 'react-router-dom';
import { ownerUpdateWatchOnboardingVideo } from 'api/owner_sdk';
import { message } from 'antd';
import { useOwnerDetails } from 'api/owners';
import { useSignedUser } from 'api/auth';

const OnboardingVideoPage = () => {
  const { data: user } = useSignedUser();
  const { data: owner } = useOwnerDetails(user?.owner_id);

  const history = useHistory();

  useEffect(() => {
    // When the user logs in, we send them to this page.
    // If they have already watched the video, we redirect them to the next step on onboarding flow.
    if (owner?.isWatchedOnboardingVideo) {
      history.push({
        pathname: '/onboarding/',
        state: { stores: owner.stores.length, ownerId: user.owner_id },
      });
    }
  }, [owner, user.owner_id, history]);

  const redirectToOnboarding = useCallback(() => {
    ownerUpdateWatchOnboardingVideo()
      .then(() => {
        history.push({
          pathname: '/onboarding',
          state: { stores: owner.stores.length, ownerId: user.owner_id },
        });
      })
      .catch((error) => message.error(error.message));
  }, [history, user.owner_id, owner.stores]);

  return (
    <OverviewLayout className="onboarding-page">
      <OnboardingVideo onNext={redirectToOnboarding} />
    </OverviewLayout>
  );
};

export default OnboardingVideoPage;
